import React from "react";



const TableBlog = ({ titulos, conteudo }) => {
    return (
        <div
            style={{
                width: "100%",
                overflowX: "auto",
                fontFamily: "'Inter', sans-serif",
                display: "flex",
                justifyContent: "center",
                padding: "10px",
            }}
        >
            <table
                style={{
                    width: "100%",
                    maxWidth: "800px",
                    borderCollapse: "collapse",
                    background: "#fff",
                }}
            >
                <thead>
                    <tr
                        style={{
                            background: "#050505",
                            color: "#fff",
                            textAlign: "left",
                        }}
                    >
                        {titulos.map((titulo, index) => (
                            <th
                                key={index}
                                style={{
                                    padding: "20px 16px",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    textTransform: "uppercase",
                                }}
                            >
                                {titulo}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {conteudo.map((item, index) => (
                        <tr
                            key={index}
                            style={{
                                background:
                                    index % 2 === 1 ? "#F3F2F1" : "#FFFFFF",
                                borderBottom: "1px solid #E5E5E5",
                            }}
                        >
                            <td
                                style={{
                                    padding: "22px 16px",
                                    fontSize: "16px",
                                    color: "#111",
                                    lineHeight: 1.6,
                                    width: "40%",
                                }}
                            >
                                {item.situacao}
                            </td>

                            <td
                                style={{
                                    padding: "22px 16px",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    color: "#2fd659",
                                    lineHeight: 1.6,
                                }}
                            >
                                {item.valor}
                            </td>
                            {item.extraOne && (
                                <td
                                    style={{
                                        padding: "22px 16px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        color: "#2fd659",
                                        lineHeight: 1.6,
                                    }}
                                >
                                    {item.extraOne}
                                </td>
                            )}
                            {item.extraTwo && (
                                <td
                                    style={{
                                        padding: "22px 16px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        color: "#2fd659",
                                        lineHeight: 1.6,
                                    }}
                                >
                                    {item.extraTwo}
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableBlog;